import React, { Fragment } from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from 'components/atoms/Button/Button';
import SvgIcon from 'components/atoms/SvgIcon/SvgIcon';
import Box from 'components/atoms/Box/Box';
import IconButton from 'components/molecules/IconButton/IconButton';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import { WHITE } from 'colours';
import { Trans } from 'react-i18next';

export default function SubsectionNavigation(props) {
  const { items, currentSubsection, onClick } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const getSubsectionName = (subSection) => {
    return subSection.translationKey ? (
      <Trans i18nKey={subSection.translationKey} />
    ) : (
      subSection.name
    );
  };

  return (
    <Fragment>
      <Box display="flex" mt={'5px'}>
        <Box
          bgcolor="secondary.main"
          display={{ xs: 'none', sm: 'block' }}
          flexGrow={1}
          mr={'4px'}
        />

        {items.map((subsection) => (
          <Fragment>
            {isMobile ? (
              <Box
                flexGrow={currentSubsection === subsection.id ? 1 : 0}
                display="flex"
                bgcolor={
                  currentSubsection === subsection.id
                    ? 'primary.main'
                    : 'secondary.main'
                }
                justifyContent="center"
                m={'2px'}
              >
                <IconButton
                  onButtonClick={() => {
                    onClick(subsection);
                  }}
                  display="inline"
                >
                  <SvgIcon width={'20px'} icon={subsection.icon} p={'5px'} />
                </IconButton>
                {currentSubsection === subsection.id && (
                  <Box display="inline" color={WHITE} mt={'5px'}>
                    <Paragraph variant="subtitle2">
                      {getSubsectionName(subsection)}
                    </Paragraph>
                  </Box>
                )}
              </Box>
            ) : (
              <Box bgcolor="secondary.main" mr={'4px'}>
                <Button
                  small
                  color={
                    currentSubsection === subsection.id
                      ? 'primary'
                      : 'secondary'
                  }
                  variant="contained"
                  onClick={() => {
                    onClick(subsection);
                  }}
                  startIcon={
                    <SvgIcon
                      width={{ xs: '20px', sm: '28px' }}
                      icon={subsection.icon}
                    />
                  }
                >
                  {getSubsectionName(subsection)}
                </Button>
              </Box>
            )}
          </Fragment>
        ))}

        <Box
          bgcolor="secondary.main"
          display={{ xs: 'none', sm: 'block' }}
          flexGrow={1}
        />
      </Box>
    </Fragment>
  );
}
